import { defineStore } from 'pinia';
import state from './state.js';
import actions from './actions.js';

export const useAccountCardStore = defineStore('accountCard', {
    state() {
        return state;
    },
    actions,
});
